
















import { Component, Vue } from 'vue-property-decorator';
import { routeName } from '@/constants/route.constants';

@Component
export default class TagIncompleteComponent extends Vue {
  public onHideEvent() {
    this.$router.replace({
      name: routeName.public.scan
    });
  }
}
